import { Component } from '@angular/core';
import { ApplicationService } from '@core/data/application.service';
import { AppConstants } from '@core/constants/app';
import { map } from 'rxjs/operators';
import * as moment from 'moment';
import { environment } from '@environment/environment';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Generic } from '@core/interfaces/entities/generic';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirmation',
  templateUrl: './confirmation.component.html',
  styleUrls: ['./confirmation.component.scss'],
})
export class ConfirmationComponent {
  public readonly translationPrefix = 'pages.confirmation';
  public readonly summary$: Observable<Generic>;

  constructor(private applicationService: ApplicationService, private route: ActivatedRoute, private translate: TranslateService) {
    const applicationId = this.route.snapshot.paramMap.get('applicationId');
    this.summary$ = this.applicationService.getStepData(applicationId, AppConstants.API_STEP_REVIEW)
      .pipe(map((response: Generic) => ({
        ...response, ...{
          applicationYear: response.coverageEffectiveDate.slice(0, 4),
          materialId: AppConstants.APPLICATION_MATERIAL_IDS[moment(response.requestedEffectiveDate, 'YYYY-MM-DD').year()],
          transaction: {
            userFullName: `${response.firstName} ${response.lastName}`,
            timestamp: moment(response.submittedAt).format('MM/DD/YYYY h:mm a'),
            transactionId: response.confirmationCode,
          },
          blueButton: {
            planName: response.planSelection.name,
            termsUrl: AppConstants.TERMS_AND_CONDITIONS_URL_MAPPING()[this.translate.currentLang],
            privacyUrl: AppConstants.PRIVACY_POLICY_URL_MAPPING()[this.translate.currentLang],
          },
        },
      })));
  }

  public blueButtonClick() {
    window.open(environment.services.blueButton.url, '_blank');
  }
}
